import {ChangeEvent, FC, HTMLAttributes, useEffect, useRef, useState} from "react";
import {CheckboxOptionProps} from "./interfaces/CheckboxOptionProps";
import classNames from 'classnames/bind';
import css from './CheckboxGroup.module.scss';


interface CheckboxGroupProps extends HTMLAttributes<HTMLInputElement> {
    values: CheckboxOptionProps[] | string[];
    onValueChange: (values: string[]) => void
}

const cx = classNames.bind(css);

const CheckboxGroup: FC<CheckboxGroupProps> = ({onValueChange, values, className = ''}) => {
    const [checkedValues, setCheckedValues] = useState<string[]>([]);
    const form = useRef<HTMLFormElement>(null);

    const parseOption = (value: string | CheckboxOptionProps): CheckboxOptionProps => {
        if (typeof value === 'string') {
            return {
                id: value,
                value: value
            }
        }
        return value;
    }

    useEffect(() => {
        onValueChange(checkedValues);
    }, [checkedValues])

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const {checked, value} = e.target;
        if (checked && !checkedValues.includes(value)) {
            setCheckedValues(prevState => [...prevState, value])
        }
        if (!checked) {
            setCheckedValues(prevState => [...prevState.filter(p => p !== value)])
        }
    }

    return (
        <form ref={form} className={cx(css.wrapper, className)}>
            {values.map(value => (
                <label key={parseOption(value).id} className={css.label}>
                    <input onChange={handleChange}
                           className={cx(css.label__input, css.input)}
                           value={parseOption(value).id}
                           type="checkbox"/> {parseOption(value).value}
                </label>
            ))}
        </form>
    );
}

export default CheckboxGroup;
